module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/game.component.css
// module id = ./src/app/web/game/game.component.css
// module chunks = main